<div class="container">
  <div class="row">
    <div class="col-md-6" style="color:black; padding-top:1%; font-size:1.4em; font-weight:bold ">
      In re Generic Pharmaceuticals Antitrust Litigation
    </div>
    <div class="col-md-6">
      <div class="float-right phoneNumber" style="font-size: 1.4em; padding-top: 3%; font-weight: bold">1-877-316-0171</div>
    </div>
    <div class="col-md-12" style="padding-left:0px; padding-right:0px">

    </div>
  </div>
</div>
<header>
  <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light  border-bottom " style="background-color: #000042 ">
    <div class="container">
      <button class="navbar-toggler" type="button" style="background-color:white" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse justify-content-center" [ngClass]="{ show: isExpanded }">
        <ul class="navbar-nav flex-grow">
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/landing']" style="color:white; font-weight:bold">All Classes Page</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link  hover_lightBlue" [routerLink]="['/certified-litigation-classes-homepage']" style="color:white; font-weight:bold">Home</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link  hover_lightBlue" [routerLink]="['/certified-litigation-classes-notice']" style="color:white; font-weight:bold">Notice/FAQs</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/certified-litigation-classes-courtdocuments']" style="color:white; font-weight:bold">Court Documents</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/register']" style="color:white; font-weight:bold">Registration</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/certified-litigation-classes-espanol']" style="color:white; font-weight:bold">Español</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/certified-litigation-classes-contact']" style="color:white; font-weight:bold">Contact Information</a>
          </li>

        </ul>
      </div>
    </div>
  </nav>

</header>
<div class="container" style="border:1px solid #bebaba">
  <div class="row text-center background-bottom">
    <div class="col-md-12 text-center img-fluid" style="margin-top:2%; margin-bottom:2%; padding-right:2%; padding-left:2%">
      <p class="text-center" style="font-size:1.0em; color:white">
        This official website is maintained by the Notice Administrator for <i>In re Generic Pharmaceuticals Antitrust Litigation</i>,
        No. 16-MD-2724 pending in the United States District Court for the Eastern District of Pennsylvania.
      </p>
    </div>
  </div>
  <br />

  <div class="row indentContent">
    <div class="col-md-12">
      <h2 class="#353535" id="FontTwo"><b>Court Documents</b></h2><br />
      <ul>
        <li>
          <a href="../../../../assets/Docs/2025-11-25 List of Entities that Opted Out of Clobetasol and Clomipramine Litigation Classes.pdf"
             target="_blank">
            2025-11-25 List of Entities that Opted Out of the Clobetasol and Clomipramine EPP litigation classes
          </a>
        </li>
        <li>

          <a href="../../../../assets/Docs/2025-06-17 Order granting the petition to appeal the Clobetasol Class Certification Order.pdf"
             target="_blank">
            2025-06-17 Order granting the petition to appeal the Clobetasol EPP Class Certification Order
          </a>
        </li>
        <li>
          <a href="../../../../assets/Docs/2025-06-17 Order granting the petition to appeal the Clomipramine Class Certification Order.pdf"
             target="_blank">
            2025-06-17 Order granting the petition to appeal the Clomipramine EPP Class Certification Order
          </a>
        </li>
        <li>
          <a href="../../../../assets/Docs/2025-05-01 Order Granting EPPs' Notice Plan and Administrator (3354; CB-480; CM-395).pdf"
             target="_blank">
            2025-05-01 Order Approving EPPs' Notice Plan and Appointing the Notice Administrator
          </a>
        </li>
        <li>
          <a href="./assets/Docs/2025-03-07 Order re EPPs' Motion for Class Certification (3275).pdf"
             target="_blank">
            2025-03-07 Order Certifying the Clobetasol and Clomipramine EPP litigation classes and Appointing Lead Counsel for the classes
          </a>
        </li>
        <li>
          <a href="./assets/Docs/2025-03-07 Opinion re EPPs' Motion for Class Certification (3274).pdf"
             target="_blank">
            2025-03-07 Opinion Regarding Class Certification
          </a>
        </li>
      </ul>
      <h6>Filings regarding the Clobetasol EPP litigation class</h6>
      <ul>
        <li>
          <a href="./assets/Docs/epp-clobetasol-amended-complaint-public-doc-167.pdf"
             target="_blank">
            2019-04-01 Clobetasol Complaint
          </a>
        </li>
      </ul>
      <h6>Filings regarding the Clomipramine EPP litigation class</h6>
      <ul>
        <li>
          <a href="./assets/Docs/epp-clomipramine-corrected-amended-complaint-public-doc-133.pdf"
             target="_blank">
            2019-06-25 Clomipramine Complaint
          </a>
        </li>
      </ul>

    </div>
  </div>





  <!--<div class="row indentContent">
    <div class="col-md-12">
      <h2 class="#353535" id="FontTwo"><b>Court Documents</b></h2><br />
      <ul>
        <li>
          <a href="../../../../assets/Docs/2025-11-25 List of Entities that Opted Out of Clobetasol and Clomipramine Litigation Classes.pdf"
             target="_blank">
            2025-11-25 List of Entities that Opted Out of Clobetasol and Clomipramine Litigation Classes
          </a>
        </li>
        <li>
          <a href="../../../../assets/Docs/2025-05-01 Order Granting EPPs' Notice Plan and Administrator (3354; CB-480; CM-395).pdf"
             target="_blank">
            2025-05-01 Order Granting EPPs' Notice Plan and Administrator
          </a>
        </li>
      </ul>
      <h6>Filings regarding the Clobetasol classes</h6>
      <ul>
        <li>
          <a href="./assets/Docs/epp-clobetasol-amended-complaint-public-doc-167.pdf"
             target="_blank">
            Clobetasol Complaint (filed April 1, 2019)
          </a>
        </li>
      </ul>
      <h6>Filings regarding the Clomipramine classes</h6>
      <ul>
        <li>
          <a href="./assets/Docs/epp-clomipramine-corrected-amended-complaint-public-doc-133.pdf"
             target="_blank">
            Clomipramine Complaint (filed June 25, 2025)
          </a>
        </li>
      </ul>
      <h6>Filings regarding both the Clobetasol and Clomipramine classes</h6>
      <ul>
        <li>
          <a href="./assets/Docs/2025-03-07 Order re EPPs' Motion for Class Certification (3275).pdf"
             target="_blank">
            Order Certifying the Clobetasol and Clomipramine Litigation Classes and Appointing Lead Counsel for the EPP Classes (entered March 7, 2025)
          </a>
        </li>
        <li>
          <a href="./assets/Docs/2025-03-07 Opinion re EPPs' Motion for Class Certification (3274).pdf"
             target="_blank">
            Opinion Regarding Class Certification (filed March 7, 2025)
          </a>
        </li>
      </ul>
    </div>
  </div>-->
  <br />
  <br />
  <div style="width:80%; margin:0 auto; text-align: center; display:block; margin-top: 2%">
    <p>
      Note: These documents are in PDF format. To view the<br />
      documents, you will need <a href="https://get.adobe.com/reader/" target="_blank"
                                  style="color:#C40A0A; font-weight:bold">Adobe Acrobat Reader</a>
      on your computer or other internet-enabled device.
    </p>
  </div>
  <div class="row text-center" id="inverse_row">
    <div class="col-md-12">
      <a href="https://get.adobe.com/reader/" target="_blank"><img src="../assets/adobe-pdf-icon.jpg" alt="Adobe Acrobat Reader" width="3%"></a>
    </div>
  </div>
  <br />
  <br />
</div>
